import moment from 'moment';
import { Link } from 'react-router';
import React from 'react';

const LightboxTitleInfo = ({ snapshot }) => {
  let cameraTime = null;
  if (snapshot.local_time && snapshot.timezone) {
    cameraTime = moment(snapshot.local_time)
      .tz(snapshot.timezone)
      .format('MMM D, YYYY h:mm A z');
  }
  return (
    <div className="align-items-baseline mt-2 row">
      <div className="col-12 col-md">
        <div className="snapshot-title">
          <strong>{snapshot.title}</strong><br/>
          <span className="snapshot-taken-time">
              <span>{moment(snapshot.created_at)
                .format('MMM D, YYYY h:mm A z')}</span>
            {cameraTime && (
              <div className="small" style={{ lineHeight: '1.0em' }}>Camera Time: {cameraTime}</div>
            )}
            </span>
        </div>
      </div>
      <div className="col-12 col-md-auto ml-md-auto">
        <div className="mr-2">
          <Link to={`/snapshots/users/${snapshot.username}`} style={{ color: '#ffffff' }}>
            {snapshot.display_name || snapshot.username}
            <span
              className="ml-3 mt-2 snapshot-avatar"
              style={{ backgroundImage: `url('${snapshot.avatar_uri}')` }}
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LightboxTitleInfo;
